import { Grid, Button } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../utils/hooks';
import { incrementStep } from '../store/reducers/stepper.reducers';

interface Props {
  disableNext: boolean;
  nextText?: string;
  onNext?: () => void;
}

export default function Footernav({ disableNext, nextText, onNext }: Props) {
  const dispatch = useAppDispatch();
  const { isColorBlindMode } = useAppSelector((state) => state.config);
  return (
    <Grid
      container
      justifyContent="flex-end"
      alignItems="center"
      height="100px"
    >
      {!disableNext && (
        <Grid item>
          <Button
            variant="contained"
            size="large"
            onClick={() => {
              onNext ? onNext() : dispatch(incrementStep());
            }}
            sx={
              isColorBlindMode
                ? {
                    backgroundColor: 'accessibility.button.main',
                    color: 'accessibility.button.contrastText',
                    textDecoration: 'underline',
                    textUnderlineOffset: '2.5px',
                    border: (theme) =>
                      `1px solid ${theme.palette.accessibility?.button?.border}`,
                    '&:hover': {
                      backgroundColor: '#222',
                      color: 'accessibility.button.contrastText',
                      textDecoration: 'underline',
                    },
                  }
                : {}
            }
          >
            {nextText ?? 'Weiter'}
          </Button>
        </Grid>
      )}
    </Grid>
  );
}
